import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { WalletProvider, getChainOptions } from "@xpla/wallet-provider";
import process from "process";
window.process = process;

getChainOptions().then((chainOptions) => {
  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(
    <WalletProvider {...chainOptions}>
      <App />
    </WalletProvider>
  );
});